"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.Wrapper = exports.Tooltip = exports.StyledButton = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
var _breakpoints = _interopRequireDefault(require("../../globals/styles/breakpoints"));
var _Button = _interopRequireDefault(require("../Button"));
var _react2 = require("motion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const StyledButton = exports.StyledButton = /*#__PURE__*/(0, _base.default)(_Button.default, process.env.NODE_ENV === "production" ? {
  target: "e169bjpw2"
} : {
  target: "e169bjpw2",
  label: "StyledButton"
})(process.env.NODE_ENV === "production" ? {
  name: "4nc06h",
  styles: "margin-left:5px;&:focus-visible{outline:1px dotted #212121;outline:5px auto -webkit-focus-ring-color;}"
} : {
  name: "4nc06h",
  styles: "margin-left:5px;&:focus-visible{outline:1px dotted #212121;outline:5px auto -webkit-focus-ring-color;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const styles = exports.styles = {
  default: process.env.NODE_ENV === "production" ? {
    name: "1uszwlo",
    styles: "text-align:left;max-width:300px"
  } : {
    name: "godunf-default",
    styles: "text-align:left;max-width:300px;label:default;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  top: /*#__PURE__*/(0, _react.css)("bottom:calc(24px + 5px);left:calc(-11vw + 9px);box-shadow:0px 1px 4px 0px rgba(0, 0, 0, 0.2);@media screen and (max-width: ", _breakpoints.default.small, "){width:50vw;left:calc(-25vw + 9px);}@media screen and (max-width: ", _breakpoints.default.large, ") and (orientation: landscape){width:50vw;}&::after{top:100%;left:50%;margin-left:-5px;border-color:white transparent transparent transparent;}" + (process.env.NODE_ENV === "production" ? "" : ";label:top;")),
  right: /*#__PURE__*/(0, _react.css)("top:0;left:35px;box-shadow:-1px 0px 4px 0px rgba(0, 0, 0, 0.2);@media screen and (max-width: ", _breakpoints.default.small, "){width:50vw;}@media screen and (max-width: ", _breakpoints.default.large, ") and (orientation: landscape){width:50vw;}&::after{top:8px;right:100%;margin-left:-5px;border-color:transparent white transparent transparent;}" + (process.env.NODE_ENV === "production" ? "" : ";label:right;")),
  bottom: /*#__PURE__*/(0, _react.css)("top:calc(24px + 5px);left:calc(-11vw + 9px);box-shadow:0px -1px 4px 0px rgba(0, 0, 0, 0.2);@media screen and (max-width: ", _breakpoints.default.small, "){width:50vw;left:calc(-25vw + 9px);}@media screen and (max-width: ", _breakpoints.default.large, ") and (orientation: landscape){width:50vw;}&::after{bottom:100%;left:50%;margin-left:-5px;border-color:transparent transparent white transparent;}" + (process.env.NODE_ENV === "production" ? "" : ";label:bottom;")),
  left: /*#__PURE__*/(0, _react.css)("top:0;right:calc(24px + 3px);box-shadow:1px 0px 4px 0px rgba(0, 0, 0, 0.2);@media screen and (max-width: ", _breakpoints.default.small, "){width:50vw;}@media screen and (max-width: ", _breakpoints.default.large, ") and (orientation: landscape){width:50vw;}&::after{top:8px;left:100%;border-color:transparent transparent transparent white;}" + (process.env.NODE_ENV === "production" ? "" : ";label:left;")),
  width: (width, place) => /*#__PURE__*/(0, _react.css)("width:", width, "!important;left:", place === 'top' || place === 'bottom' ? `calc((-${width} / 2) + 9px) !important` : place === 'right' ? '35px' : 'initial', ";" + (process.env.NODE_ENV === "production" ? "" : ";label:width;"))
};
const Tooltip = exports.Tooltip = /*#__PURE__*/(0, _base.default)(_react2.motion.div, process.env.NODE_ENV === "production" ? {
  target: "e169bjpw1"
} : {
  target: "e169bjpw1",
  label: "Tooltip"
})(process.env.NODE_ENV === "production" ? {
  name: "gsdyt8",
  styles: "position:absolute;width:22vw;text-align:center;padding:0.5em;border-radius:10px;background-color:white;z-index:9999;&::after{content:'';position:absolute;border-width:5px;border-style:solid;}"
} : {
  name: "gsdyt8",
  styles: "position:absolute;width:22vw;text-align:center;padding:0.5em;border-radius:10px;background-color:white;z-index:9999;&::after{content:'';position:absolute;border-width:5px;border-style:solid;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "e169bjpw0"
} : {
  target: "e169bjpw0",
  label: "Wrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1m1qpau",
  styles: "display:block;width:max-content;position:relative"
} : {
  name: "1m1qpau",
  styles: "display:block;width:max-content;position:relative",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});